import { writable } from 'svelte/store';

// TODO: Move this to an object: can count duplicates in the graph and "push" them up the list when displaying.
const AddressStore = writable({});

export default AddressStore;
